export interface Calculate {
  users: number
  months: number
  upgrade: boolean
  months_gift: number
  currency: string
  price: number
}

export interface CalculatePayload {
  users: number
  months: number
  upgrade: boolean
}

export interface BuySubscriptionPayload extends CalculatePayload {
  mode: string
}

export interface TariffName {
  free: string
  pro: string
  scriptolog: string
}

export enum ETariffName {
  free = 'free',
  pro = 'pro',
  scriptolog = 'scriptolog',
}

export interface ModalParams {
  modalStep: EModalStep
  enableMonths: boolean
  enableUsers: boolean
  userCount: number
}

export enum EModalStep {
  tariffs = 'tariffs',
  payment = 'payment',
}
